import React from 'react'
import { faInstagram} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Andor from '../img/Andor.jpg'
import Christo from '../img/Christo.jpg'

export class AboutUs extends React.PureComponent {
    render() {

        const imgStyle = {
            width:'200px',
            height:'200px'
        }
        return (
            <section id="about" className="mb-5">
                <div className="about d-flex justify-content-center align-items-center">
                    <h2 className="text-white">Over ons</h2>
                </div>
                <div className="container">
                    <div className="w-100">
                        <h3 className="text-center mt-5">Oprichters</h3>
                        <div className="d-flex flex-row justify-content-around align-content-center">
                            <div className="d-flex flex-row flex-wrap  justify-content-around align-content-center">
                            <div className="d-flex flex-column mx-5 my-5">
                                <h3 className="text-center">Christo Lappas</h3>
                                <div className="d-flex align-self-center"><img alt="Christo Lappas Headshot" style={imgStyle} src={Christo}></img></div>
                                <a className="align-self-center" href="https://www.instagram.com/ieesaa/"><button className="align-self-center my-2 py-1 button-instagram"><FontAwesomeIcon icon={ faInstagram}/> Follow</button></a>
                                <p className="text-center align-self-center w-50">Info about Christo here</p>
                            
                            </div>
                            <div className="d-flex flex-column mx-5  my-5">
                                <h3 className="text-center">Andor Vrinssen</h3>
                                <div className="align-self-center"><img alt="Andor Vrinssen Headshot"  style={imgStyle} src={Andor}></img></div>
                                <a className="align-self-center" href="https://www.instagram.com/andorvrinssen/"><button className="align-self-center my-2 py-1 button-instagram"><FontAwesomeIcon icon={ faInstagram}/> Follow</button></a>
                                <p className="text-center align-self-center w-50">Info about Andor here</p>
                             
                            </div>
                           </div>
                        </div>

                    </div>
                </div>
            </section>
        )
    }
}
export default React.memo(AboutUs)
